import {UISelection} from "../u-i-selection";

export abstract class UISelectionBuilder {
    /* STATIC */

    /* INSTANCE */
    protected constructor() {
    }

    /**
     * Build the UISelection.
     */
    public abstract build(): UISelection;
}
